import "./RedeDeOficinas.css";
import BannerInterior from "../../components/BannerInterior/BannerInterior";
import banner from "../../img/banners/redes-oficinas.jpg";
import iconMapPin from "../../img/rede-oficinas/icons/map-pin.svg";
import iconCellphone from "../../img/rede-oficinas/icons/cellphone.svg";
import iconEmail from "../../img/rede-oficinas/icons/email.svg";
import Button from "../../components/Button";
import {useNavigate} from "react-router-dom";
import SimpleMap from "../../components/GoogleMap/SimpleMap";
import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {Trans, useTranslation} from "react-i18next";
import axios from "axios";
import toast from "react-hot-toast";
import Select from "react-select";
import {CurrentUser, Loading} from "../../utils/Utilities";
import Moment from "moment";
import "moment/locale/pt";

Moment.locale("pt");

function RedeDeOficinas(props) {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const currentUser = CurrentUser();

    const [points, setPoints] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pointClicked, setPointClicked] = useState(null);

    // evita setState depois de unmount
    const aliveRef = useRef(true);
    useEffect(() => {
        aliveRef.current = true;
        return () => {
            aliveRef.current = false;
        };
    }, []);

    const normalizeWorkshop = useCallback((d) => {
        const w = {...d};

        w.lat = Number.isFinite(+w.lat) ? +w.lat : 0;
        w.lng = Number.isFinite(+w.lng) ? +w.lng : 0;

        // schedule parsing
        try {
            const aux = JSON.parse(w.scheduleAux || "{}");
            w.scheduleWeek = "Segunda a sexta:";
            w.morningHours = aux?.timeW1 + (aux?.timeW2 ? ` às ${aux?.timeW2}` : "");
            w.afternoonHours = (aux?.timeW3 ? `${aux?.timeW3} às ` : "") + (aux?.timeW4 || "");
            w.scheduleSaturday = `Sábado: ${
                aux?.timeWD1 ? `${aux?.timeWD1} às ${aux?.timeWD2}` : "Encerrado"
            }`;
        } catch {
            // mantém sem horários formatados
        }

        // react-select precisa de label/value para trabalhar melhor
        w.value = w.id;
        w.label = w.title;

        return w;
    }, []);

    const getImageWorkshop = useCallback(async (workshop) => {
        if (!workshop) return null;

        const w = {...workshop};
        const img = w?.image ?? "no-image.png";

        // se já for base64 não faz fetch
        if (typeof img === "string" && img.startsWith("data")) return w;

        try {
            const {data} = await axios.get(global.api_url + "WorkShops/Image/" + img);
            return {...w, image: data?.base64 ?? "no-image.png"};
        } catch (err) {
            toast.error(err?.message || "Erro ao obter imagem da oficina");
            return w;
        }
    }, []);

    const pickDefaultWorkshop = useCallback(
        (list) => {
            if (!Array.isArray(list) || list.length === 0) return null;

            // prioridade: default do user
            const defaultId = currentUser?.defaultWorkshop ? String(currentUser.defaultWorkshop) : null;
            if (defaultId) {
                const found = list.find((x) => String(x?.id) === defaultId);
                if (found) return found;
            }

            // fallback: primeiro
            return list[0];
        },
        [currentUser]
    );

    const getAllWorkshops = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.get(global.api_url + "Workshops/GetAllFront");
            const data = Array.isArray(response?.data) ? response.data : [];

            const normalized = data.map(normalizeWorkshop);

            if (!aliveRef.current) return;

            setPoints(normalized);

            // seleciona default e já carrega imagem
            const initial = pickDefaultWorkshop(normalized);
            if (initial) {
                const withImage = await getImageWorkshop(initial);
                if (aliveRef.current) setPointClicked(withImage);
            } else {
                setPointClicked(null);
            }
        } catch (error) {
            if (aliveRef.current) setPoints([]);
            //toast.error(error?.message || "Erro ao obter oficinas", { duration: 4000 });
        } finally {
            if (aliveRef.current) setLoading(false);
        }
    }, [getImageWorkshop, normalizeWorkshop, pickDefaultWorkshop]);

    useEffect(() => {
        getAllWorkshops();
    }, [getAllWorkshops]);

    const handleWorkshopChange = useCallback(
        async (workshop) => {
            if (!workshop) return;
            setPointClicked(workshop); // feedback imediato
            const withImage = await getImageWorkshop(workshop);
            if (aliveRef.current) setPointClicked(withImage);
        },
        [getImageWorkshop]
    );

    const nowIsoNoZ = useMemo(() => {
        const iso = Moment(new Date().toUTCString()).toISOString();
        return iso.replace("Z", "");
    }, []);

    const baseSchedule = useCallback(
        (title) => ({
            title,
            start: nowIsoNoZ,
            end: nowIsoNoZ,
            accountId: currentUser?.id ?? 0,
            firstName: currentUser?.firstName ?? "",
            lastName: currentUser?.lastName ?? "",
            email: currentUser?.email ?? "",
            phone: "",
            nif: "",
            vehiculeId: 0,
            plate: "",
            brand: "",
            model: "",
            kms: 0,
            workShopId: pointClicked?.id ?? 0,
            notes: "",
            serviceTypeId: 0,
            services: [],
        }),
        [currentUser, nowIsoNoZ, pointClicked?.id]
    );

    const appointment = useCallback(() => {
        if (!pointClicked) return;

        props.setAppointmentData({
            ...props.appointmentData,
            shopId: pointClicked,
            shop: pointClicked,
            schedule: {
                ...baseSchedule("Marcação Site"),
                accountId: 0,
                firstName: "",
                lastName: "",
                email: "",
            },
        });

        navigate("/Marcacao");
    }, [baseSchedule, navigate, pointClicked, props]);

    const budget = useCallback(() => {
        if (!pointClicked) return;

        props.setAppointmentData({
            ...props.appointmentData,
            workShop: pointClicked,
            shop: pointClicked.title,
            schedule: baseSchedule("Pedido de Orçamento"),
        });

        navigate("/Orcamento");
    }, [baseSchedule, navigate, pointClicked, props]);

    /*const phoneHint = useMemo(() => {
        const c = pointClicked?.cellphone || "";
        if (!c) return "";
        return c.startsWith("9") ? "chamada para a rede móvel nacional" : "chamada para a rede fixa nacional";
    }, [pointClicked?.cellphone]);*/

    const phoneHint = (number = "") => {
        const c = number || "";
        if (!c) return "";
        return c.startsWith("9") ? "chamada para a rede móvel nacional" : "chamada para a rede fixa nacional";
    }

    return (
        <div className="Main-Class">
            <BannerInterior name={t("WorkShopNetWork.banner_name")} imagem={banner}/>

            <div className="section redes-oficinas pt-xxl-4 pt-5 pb-xxl-1 pb-5">
                <div className="container-fluid ps-lg-0">
                    <div className="row align-items-xxl-center g-5">
                        {Loading(loading, 30)}

                        {!loading && points.length > 0 && (
                            <>
                                <div className="col-lg-5">
                                    <SimpleMap
                                        points={points}
                                        pointClicked={pointClicked}
                                        setPointClicked={(data) => handleWorkshopChange(data)}
                                    />
                                </div>

                                {pointClicked && (
                                    <div className="col-xxl-5 col-lg-7 content-left">
                                        <div className="block-side-map">
                                            <div className="title fw-bold mb-5">
                                                <Trans i18nKey="WorkShopNetWork.title"/>
                                            </div>

                                            <div className="title fw-bold mb-5">
                                                <Select
                                                    classNamePrefix="select"
                                                    className="form-control"
                                                    isSearchable
                                                    value={pointClicked}
                                                    placeholder={t("Keywords.search")}
                                                    options={points}
                                                    getOptionLabel={(option) => `${option.title}`}
                                                    getOptionValue={(option) => String(option.id)}
                                                    onChange={handleWorkshopChange}
                                                />
                                            </div>

                                            <div className="card oficina rounded-0 mb-5">
                                                <div className="row g-0">
                                                    <div className="col-sm-7">
                                                        <div className="card-body">
                                                            <div className="name font-poppins text-red fw-bold mb-3">
                                                                {pointClicked?.title}
                                                            </div>

                                                            <div className="details">
                                                                <div className="d-flex align-items-start mb-3">
                                                                    <img
                                                                        alt={pointClicked?.title}
                                                                        className="icon-map me-2"
                                                                        src={iconMapPin}
                                                                    />
                                                                    <div className="d-block">
                                                                        <div
                                                                            className="address">{pointClicked?.address}</div>
                                                                        {pointClicked?.postalCode + " " + pointClicked?.locality}
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex align-items-middle mb-3">
                                                                    <img
                                                                        alt={"Localização " + pointClicked?.title}
                                                                        className="me-2"
                                                                        src={iconMapPin}
                                                                    />
                                                                    <div>
                                                                        <a
                                                                            href={`https://www.google.com/maps/search/?api=1&query=${pointClicked?.lat}%2C${pointClicked?.lng}`}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                        >
                                                                            {pointClicked?.lat + " , " + pointClicked?.lng}
                                                                        </a>
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex align-items-start mb-3">
                                                                    <img
                                                                        alt={"Telefone " + pointClicked?.title}
                                                                        className="me-2"
                                                                        src={iconCellphone}
                                                                    />

                                                                    <div className="d-flex flex-column">
                                                                        <div>
                                                                            <a href={`tel:${pointClicked?.cellphone}`}>{pointClicked?.cellphone}</a>
                                                                        </div>

                                                                        <small className="text-muted" style={{
                                                                            fontSize: "0.75rem",
                                                                            lineHeight: 1.1
                                                                        }}>
                                                                            *{phoneHint(pointClicked?.cellphone)}
                                                                        </small>
                                                                    </div>
                                                                </div>

                                                                {!!pointClicked?.phone && (
                                                                    <div className="d-flex align-items-start mb-3">
                                                                        <img
                                                                            alt={"Telefone " + pointClicked?.title}
                                                                            className="me-2"
                                                                            src={iconCellphone}
                                                                        />

                                                                        <div className="d-flex flex-column">
                                                                            <div>
                                                                                <a href={`tel:${pointClicked?.phone}`}>{pointClicked?.phone}</a>
                                                                            </div>

                                                                            <small className="text-muted" style={{
                                                                                fontSize: "0.75rem",
                                                                                lineHeight: 1.1
                                                                            }}>
                                                                                *{phoneHint(pointClicked?.phone)}
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                )}


                                                                {!!pointClicked?.email && (
                                                                    <div className="d-flex align-items-middle mb-3">
                                                                        <img
                                                                            alt={"Email " + pointClicked?.title}
                                                                            className="me-2"
                                                                            src={iconEmail}
                                                                        />
                                                                        <div>
                                                                            <a href={`mailto:${pointClicked?.email}`}>{pointClicked?.email}</a>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <p className="horario fw-bold mb-1">{t("Keywords.schedule")}</p>

                                                            <div className="block-horario d-flex mb-2">
                                                                <div>{pointClicked?.scheduleWeek}</div>
                                                                <div className="d-block ms-1">
                                                                    {pointClicked?.morningHours}
                                                                    <div
                                                                        className="d-block mt-1">{pointClicked?.afternoonHours}</div>
                                                                </div>
                                                            </div>

                                                            <div>{pointClicked?.scheduleSaturday}</div>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-5">
                                                        <div className="img-oficina h-100">
                                                            {pointClicked?.image?.startsWith("data") ? (
                                                                <img
                                                                    alt={pointClicked?.title}
                                                                    style={{
                                                                        height: "100%",
                                                                        width: "100%",
                                                                        objectFit: "cover"
                                                                    }}
                                                                    src={pointClicked?.image}
                                                                />
                                                            ) : (
                                                                Loading(loading, 30)
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {pointClicked?.available === true ? (
                                                <div className="buttons">
                                                    <div className="d-flex">
                                                        <Button
                                                            onClick={appointment}
                                                            type="button"
                                                            buttonStyle="button-loginscreen-solid"
                                                            buttonSize="button-size-large"
                                                        >
                                                            {t("WorkShopNetWork.button_schedule")}
                                                        </Button>

                                                        <Button
                                                            onClick={budget}
                                                            type="button"
                                                            buttonStyle="btn-black"
                                                            buttonSize="button-size-large"
                                                        >
                                                            {t("WorkShopNetWork.button_budget")}
                                                        </Button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>Serviço de agendamento temporáriamente indisponível.</>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}

                        {!loading && points.length === 0 && (
                            <div className="col-12">
                                <div className="text-center py-5">
                                    <strong>{t("Keywords.no_results") || "Sem oficinas disponíveis."}</strong>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RedeDeOficinas;
